import { render } from "./AddSupplier.vue?vue&type=template&id=1576e2da&scoped=true"
import script from "./AddSupplier.vue?vue&type=script&lang=js"
export * from "./AddSupplier.vue?vue&type=script&lang=js"

import "./AddSupplier.vue?vue&type=style&index=0&id=1576e2da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1576e2da"]])

export default __exports__